// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".CatalogSubCategories{margin-bottom:1.5rem}.CatalogSubCategories__titleWrapper>.Title{margin-bottom:1rem}.CatalogSubCategories__content>div>div{margin-bottom:.5rem;padding-left:.25rem;padding-right:.25rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
